export default "__VITE_ASSET__c290980f__"